import {Component, OnDestroy} from "@angular/core";
import {NavigationEnd, Router} from "@angular/router";


@Component({
  selector: "app-unauthenticated-wrapper",
  templateUrl: "./unauthenticated-wrapper.component.html",
  styleUrls: ["./unauthenticated-wrapper.component.css"]
})

export class UnauthenticatedWrapperComponent implements OnDestroy {
  currentRouteUrl: string;

  constructor(
    private router: Router,
  ) {
    this.currentRouteUrl = "";
    // @ts-ignore
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        // @ts-ignore
        this.currentRouteUrl = event.urlAfterRedirects;
      }
    });
  }

  redirectToLogin() {
    this.router.navigate(["/auth/login"]);
  }

  ngOnDestroy() {
  }

}
